<div class="login-container">
  <div class="login text-center">
    <div>
      <button class="btn btn-lg btn-round btn-primary " (click)="signin()">
            <i class="fa fa-sign-in"></i></button>
            <div class="btn-text">Sign in</div>
    </div>
  </div>
</div>